import React, {Component} from 'react';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
    }

    render() {
        if (this.state.hasError) {
            return <div className="bg-light text-center" style={{
                width:window.innerWidth,
                height:window.innerHeight,
                paddingTop: window.innerHeight/2,
                color: "#888888"
            }}>
                <h1><i>Ha ocurrido un error :(</i></h1>;
            </div>
        }
        return this.props.children;
    }
}
export default ErrorBoundary